



































































































































import Vue from 'vue';
import TransactionItemDimension from '../models/TransactionItemDimension';
import IconButton from '@/components/IconButton.vue';
import MoneyDisplay from '@/components/MoneyDisplay.vue';
import store, { TransactionStore } from "../services/TransactionStore";
import Dimension from "@/modules/transactions/models/Dimension"
import LookupComboBox from "./LookupComboBox.vue";
import eventBus from '@/services/eventBus';
import { t } from "@/plugins/i18n";


interface Data {
    store: TransactionStore;
    totalTemp: number;
}

interface Methods{
    onRowClick(item: any): void;
    toggleDeleting(item: TransactionItemDimension, event?: Event): void;
    stretchDetailCells(): void;
    findRowDeleteButton(event?: Event): HTMLButtonElement | null;
    confirmDeletion(item: TransactionItemDimension): void;
    dimCodes(status: number): Dimension[];
    onDimCodeValueChanged(item: TransactionItemDimension, newValue: any): void;
    onValueChanged(item: TransactionItemDimension): void;
    transactionCurrency(item: TransactionItemDimension): string | undefined;

}

interface Computed{
    totalDisplay: string;
}

interface Props{
    dataItems: TransactionItemDimension[];
    dimColumns: any;
    dimCodeType: number;
}


export default Vue.extend<Data, Methods,Computed,Props>({

    data() {
        return {
            store,
            totalTemp: 0,
        };
    },
    mounted() {
        // A Chrome a fókuszálható gyerek nélküli görgethető konténert tab-célponttá teszi
        // (üres gridnél a Tab ide állna meg a következő vezérlő helyett) — kivesszük a tab-sorrendből.
        (this.$el as HTMLElement).querySelector(".k-grid-content")?.setAttribute("tabindex", "-1");
    },
    methods:{
        onRowClick(item){
            this.totalTemp = item.dataItem.total;
            this.$emit("onRowClick",item);
        },
        toggleDeleting(item, event?: Event){

            // Mégse/Esc esetén a fókuszált gomb kikerül a DOM-ból, ezért még a bezárás előtt
            // eltesszük a sorhoz tartozó kuka ikont, hogy oda tudjuk visszaadni a fókuszt.
            const trashBtn = item.deleting ? this.findRowDeleteButton(event) : null;

            item.deleting = !item.deleting;

            this.$nextTick(() => {
                this.stretchDetailCells();
                // Törlés-megerősítőnél a Megerősítés gomb kapja a fókuszt (Enter = törlés, Esc = mégse)
                if(item.deleting){
                    const btn = (this.$el as HTMLElement).querySelector<HTMLButtonElement>(".detail-row .con_btn");
                    btn?.focus();
                }
                else {
                    trashBtn?.focus();
                }
            });
        },
        // A Kendo a detail-cellára eggyel kevesebb colspan-t ad, mint ahány adatoszlop van
        // (Grid.js: a levél-oszlopok száma mínusz 1 az expandField miatt), ezért a megerősítő
        // doboza nem ér el a sor jobb széléig, és a gombjai sem ülnek a jobb szélen.
        // A hiányzó colspan-t a saját sorának cellaszámából pótoljuk.
        stretchDetailCells(){
            (this.$el as HTMLElement).querySelectorAll<HTMLTableCellElement>("td.k-detail-cell").forEach((cell) => {
                const masterRow = cell.closest("tr")?.previousElementSibling as HTMLElement | null;
                if (!masterRow) return;
                // a hierarchia-cellát a detail-sor külön tartalmazza, azt nem kell átfognia
                const dataCells = masterRow.children.length - 1;
                if (dataCells > 0 && cell.colSpan < dataCells) cell.colSpan = dataCells;
            });
        },
        // A megerősítő a Kendo detail-sorában van, ami közvetlenül a saját sora után áll:
        // a megerősítőből kiindulva az előző <tr> a dimenzió sora, abban keressük a kuka gombot.
        findRowDeleteButton(event?: Event): HTMLButtonElement | null {
            const origin = (event?.target as HTMLElement) ?? (document.activeElement as HTMLElement);
            const masterRow = origin?.closest("tr")?.previousElementSibling as HTMLElement | null;
            return masterRow?.querySelector<HTMLElement>(".fa-trash")?.closest("button") ?? null;
        },
        confirmDeletion(item){
            // Törlés után a helyére lépő sor (ha az utolsót töröltük, az előző) első szerkeszthető
            // mezője — a Dimenzió kód — kapja a fókuszt, hogy a rácson folytatható legyen a munka.
            const idx = this.dataItems.indexOf(item);
            const next = this.dataItems[idx + 1] ?? this.dataItems[idx - 1] ?? null;

            this.$emit("dimDelete",item);
            item.deleting = false;

            if(!next)
                return;

            // A sor csak kijelölve szerkeszthető (inEdit), enélkül nincs is input a cellában.
            store.selectedDimension = next;
            this.$nextTick(() => {
                const field = this.$refs['firstField_' + this.dataItems.indexOf(next)] as any;
                field?.$el?.querySelector('input')?.focus();
            });
        },
        dimCodes(dimCodeType){
            return this.store.dimensions.filter((i: Dimension) => i.type == dimCodeType)
        },
        onDimCodeValueChanged(item,newValue){
            if(store.transactionItemsDimensions.filter(x => x.head == item.head && x.dimCodeType == item.dimCodeType && x.id != item.id).some(i => i.dimCode == newValue.id)){
                eventBus.$emit("error", t("Transactions_LetezikMarIlyenDimenziokoduTetel"));
            }else{
                item.dimCode = newValue.id;
                item.dimCodeName = newValue.dimcode;
                item.accGroup = newValue.accGroup;
                item.accGroupName = store.accGroups.find(x => x.id == newValue.accGroup).name
            }
        },
        onValueChanged(item){
            const ogItem = store.originalTransactionItemsDimensions.find(x => x.id === item.id)
            if(!ogItem)
                return
            
            const fieldsToCheck: (keyof TransactionItemDimension)[] = ['dimCode','total']
            for (const key of fieldsToCheck) {
                if(item[key] != ogItem[key]){
                    const exists = this.store.modifiedDimensions.some(x => x.id === item.id);
                    if (!exists) {
                        this.store.modifiedDimensions.push(item);
                    }
                    return
                }
            }

            this.store.modifiedDimensions = this.store.modifiedDimensions.filter(x=> x.id !== item.id)
        },
        transactionCurrency(item){
            return store.transactionItems.find(x => x.id == item.head)?.currency 
        }
    },
    computed:{
        totalDisplay:{
            get() {
                return this.totalTemp
                ? new Intl.NumberFormat('hu-HU',{ maximumFractionDigits: 2}).format(this.totalTemp)
                : '';
            },
            set(val) {
            const normalized = val
                .replace(/\s/g, '')      // szóközök eltávolítása
                .replace(',', '.');      // magyar vessző -> JS pont

            const numeric = parseFloat(normalized);

            this.totalTemp = Number(numeric)
            }
        }
    },
    props: {
        dataItems: {
            type: Array as () => TransactionItemDimension[],
            required: true
        },
        dimColumns: {
            type: Array as () => any[],
            required: true
        },
        dimCodeType:{
            type: Number,
            required: true
        }
    },
    components:{
        IconButton,
        MoneyDisplay,
        LookupComboBox
    }
});



